export enum ReportConfigurationType {
    NONE = 'NONE',
    // ATTRITION = 'ATTRITION',
    DELIVERY = 'DELIVERY',
    SUBSCRIBER = 'SUBSCRIBER',
    MONTHLY_UNIQUES = 'MONTHLY_UNIQUES',
    PUB_NETWORK = 'PUB_NETWORK',
    APP_MESSAGE = 'APP_MESSAGE',
    LIVE_ACTIVITY = 'LIVE_ACTIVITY',
}
